import {
  StageInterface,
  LotForReportsInterface,
} from "@/v2/types/StageInterface";
import { LotStatus } from "@/enums/LotStatus";
import LotConditionsEnum from "@/v2/enums/LotConditions";

interface CategoryData {
  quantity: number;
  value: number;
}

interface ContractCounts {
  unconditional: CategoryData;
  underContract: CategoryData;
}

export interface ClassifiedLotsResult {
  all: ContractCounts;
  [stageId: string]: ContractCounts;
}

const classifyActiveContractLots = (
  stages: StageInterface[]
): ClassifiedLotsResult => {
  const result: ClassifiedLotsResult = {
    all: {
      unconditional: { quantity: 0, value: 0 },
      underContract: { quantity: 0, value: 0 },
    },
  };

  if (!stages || !Array.isArray(stages) || stages.length === 0) {
    return result;
  }

  stages.forEach((stage) => {
    result[stage._id] = {
      unconditional: { quantity: 0, value: 0 },
      underContract: { quantity: 0, value: 0 },
    };

    stage.lots.forEach((lot: LotForReportsInterface) => {
      const lotPrice =
        lot.price &&
        ["fixed", "from"].includes(lot.price.type?.toLowerCase()) &&
        lot.price.value
          ? lot.price.value
          : 0;

      const isUnconditional =
        lot.status === LotStatus.UNCONDITIONAL ||
        (lot.status === LotStatus.UNDER_CONTRACT &&
          lot.conditions === LotConditionsEnum.UNCONDITIONAL);

      const isUnderContractWithConditions =
        lot.status === LotStatus.UNDER_CONTRACT &&
        lot.conditions !== LotConditionsEnum.UNCONDITIONAL;

      if (isUnconditional) {
        result[stage._id].unconditional.quantity++;
        result[stage._id].unconditional.value += lotPrice;
        result.all.unconditional.quantity++;
        result.all.unconditional.value += lotPrice;
      } else if (isUnderContractWithConditions) {
        result[stage._id].underContract.quantity++;
        result[stage._id].underContract.value += lotPrice;
        result.all.underContract.quantity++;
        result.all.underContract.value += lotPrice;
      }
    });
  });

  return result;
};

export default classifyActiveContractLots;
